export default __webpack_public_path__ + "static/media/francheville09.8efc3d05.jpg";